export const postsPerPage: number = 8
